import Swiper from 'swiper';
import { Keyboard, A11y, Mousewheel, FreeMode } from 'swiper/modules';

class Contact {
  constructor() {
    const parent = window.wrapper.querySelector('.contact-template')
    if (!parent)
      return
    Contact.initSlider(parent);
    Contact.initTabs(parent);
    Contact.initCopyBtn(parent);
  }

  static swiperResizeCallBack(swiper) {
    swiper.slideTo(1, 0, false);
    if ( swiper.$wrapperEl ) {
      for (let index = 0; index < swiper.$wrapperEl.length; index++) {
        const wrapper = swiper.$wrapperEl[index];
        wrapper.style.transform = '';
      }
    }
  }

  static swiperUpdateCallback(swiper){
    const swiperEl = swiper.el;
    const sliderWidth = swiperEl.getBoundingClientRect().width;
    let slidesDims = 0;

    swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {
      slidesDims += slide.getBoundingClientRect().width + 30;
    });
    swiperEl.classList.toggle('swiper-no-swiping', sliderWidth > slidesDims);
    swiperEl.style.cursor = sliderWidth > slidesDims ? '' : 'grab';
  }

  static initSlider(parent) {
    const slider = parent.querySelector('.contact-template__cards')
    return new Swiper(slider, {
      modules: [Keyboard, A11y, Mousewheel, FreeMode],
      grabCursor: true,
      spaceBetween: 12,
      speed: 600,
      touchRatio: 0.85,
      slideToClickedSlide: true,
      freeMode: true,
      slidesPerView: 'auto',
      mousewheel: {
        forceToAxis: true
      },
      breakpoints: {
        768: {
          spaceBetween: 30
        }
      },
      on: {
        resize: (swiper) => {
          this.swiperResizeCallBack(swiper);
          this.swiperUpdateCallback(swiper);
        },
        init: this.swiperUpdateCallback,
      }
    });
  }

  static initTabs(parent) {
    const cards = parent.querySelectorAll('.contact-card')
    const tabs = parent.querySelectorAll('.contact-template__tab')

    cards.forEach((card) => {
      const link = card.querySelector('a')
      link.addEventListener('click', (e) => {
        e.preventDefault()
        const tabUrl = new URL(link)
        const tab = parent.querySelector(tabUrl.hash)
        if (!tab)
          return

        cards.forEach((item) => item.classList.remove('active'))
        card.classList.add('active')

        tabs.forEach((tab) => tab.setAttribute('aria-hidden', 'true'))
        tab.removeAttribute('aria-hidden')
        tab.focus()
      })
    });
  }

  static initCopyBtn(parent) {
    // Clipboard API Only works in HTTPS
    const copyBtns = parent.querySelectorAll('.js-btn-copy');

    copyBtns.forEach((btn) => {

      btn.addEventListener('click', (ev) => {
        const toCopy = ev.target.dataset.copy;
        if (toCopy) {
          navigator.clipboard.writeText(toCopy)
            .then(() => {
              ev.target.classList.add('js-copied');
              setTimeout(() => {
                ev.target.classList.remove('js-copied');
              }, 2000);
            })
            .catch((err) => {
              console.log('Something went wrong', err);
            })
        }
      });

    });
  }
}

export default Contact;
